import { FabricObject, Polyline } from 'fabric';

import {
  DRAW_OBJECT_TYPE_POLYLINE,
  DRAW_OBJECT_TYPE_LINE,
  OBJECT_DATA_SHAPE_KEY,
} from '../draw-canvas.constants';

export const isLine = (object: FabricObject) => {
  return (
    object.type.toLowerCase() === DRAW_OBJECT_TYPE_POLYLINE &&
    object instanceof Polyline &&
    OBJECT_DATA_SHAPE_KEY in object &&
    object[OBJECT_DATA_SHAPE_KEY] === DRAW_OBJECT_TYPE_LINE
  );
};
